<template>
    <div class="view-invoices-page">
        <base-header
            class="warehouse-main-page__header"
            :titulo="getPageTitle()"
            :voltarPara='true'
        />
        <div class="view-container-wrapper">
            <div class="content">
                <section
                    class="upload_section"
                    v-if="this.warehouseId"
                >
                    <div class="upload_card">
                        <div class="warehouse-info_header">
                            <h3 class="warehouse-info_title">
                                <i class="warehouse-icon el-icon-location-information"></i>
                                {{ checkValidInformation(warehouseInformation && warehouseInformation.unidade) }}
                            </h3>
                        </div>
                        <div
                            class="warehouse-info"
                            :class="{ 'warehouse-info--five-columns': isPortView }"
                        >
                            <div class="warehouse-info_field">
                                <span class="warehouse-info_label">{{ translate('view_warehouse.' + warehouseType.toLowerCase() + '_lyra_id') }}</span>
                                <span class="warehouse-info_text">{{ checkValidInformation(warehouseInformation.codigoLyra) }}</span>
                            </div>
                            <div class="warehouse-info_field">
                                <span class="warehouse-info_label">{{ translate('view_warehouse.senave') }}</span>
                                <span class="warehouse-info_text">{{ checkValidInformation(warehouseInformation.habilitacaoSenave) }}</span>
                            </div>
                            <div class="warehouse-info_field">
                                <span class="warehouse-info_label">{{ translate('view_warehouse.' + warehouseType.toLowerCase() + '_code') }}</span>
                                <span class="warehouse-info_text">{{ checkValidInformation(warehouseInformation.codigoSucursal) }}</span>
                            </div>
                            <div class="warehouse-info_field">
                                <span class="warehouse-info_label">{{ translate('view_warehouse.location') }}</span>
                                <span class="warehouse-info_text">{{ checkValidInformation(warehouseInformation.localidade) }}</span>
                            </div>
                            <div
                                v-if="isPortView"
                                class="warehouse-info_field"
                            >
                                <span class="warehouse-info_label">{{ translate('view_warehouse.geographic_location') }}</span>
                                <span class="warehouse-info_text">{{ formatGeographicLocation() }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <totalizers-ports ref="totalizers-ports" :filters="filters" :portId="warehouseId" v-if="getPageType() === 'PORTO'" />

                <section
                    v-if="warehouseId"
                    class="warehouse-loan-control_section"
                >
                    <div class="warehouse-loan-control_section_header">
                        <h3 class="loan-control_section_title">
                            {{ translate(`view_loan_modal.loan_management`) }}
                        </h3>

                        <div>
                            <el-button
                                slot="reference"
                                type="text"
                                class="view-statement__btn"
                                @click="
                                    showModalViewStatement = !showModalViewStatement
                                "
                            >
                                {{ translate(`view_loan_modal.view_statement`) }}
                            </el-button>
                        </div>
                    </div>

                    <div class="counter-blocks_section" v-if="Object.keys(formattedLoanData).length > 0">
                        <simple-counter-block
                            v-if="formattedLoanData.volumeRecebido"
                            iconClass="lyra-icon lyra-flecha-cima-circulada"
                            :data="formattedLoanData.volumeRecebido"
                        />
                        <simple-counter-block
                            v-if="formattedLoanData.volumeEnviado"
                            iconClass="lyra-icon lyra-flecha-baixo-circulada"
                            :data="formattedLoanData.volumeEnviado"
                        />
                        <simple-counter-block
                            v-if="formattedLoanData.saldo"
                            title="Saldo"
                            :data="formattedLoanData.saldo"
                        />
                    </div>
                </section>

                <section class="warehouse_operations_section">
                    <div class="warehouse-info_section_header">
                        <h3 class="operations_history_section_title">
                            {{ translateViewFactoryOperationsList() }}
                        </h3>
                    </div>

                    <search-filters class="search-filters" @changeFilters="changeFilters" />

                    <warehouse-transaction-list class="transaction-list" :filters="filters" @refresh-loan-totalizers="refreshLoanTotalizers"/>
                </section>
            </div>
        </div>
        <view-statement-modal
            v-if="showModalViewStatement"
            :show="showModalViewStatement"
            :selectedFacilityLoan="warehouseId"
            @close="closeModal()"
        />
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import SearchFilters from '@/modules/warehouse/views/pages/viewWarehouse/components/filters/index.vue';
import WarehouseTransactionList from '@/modules/warehouse/views/pages/viewWarehouse/components/transaction-list/index.vue';
import ArmazemModuleService from '@/services/ArmazemModuleService';
import TotalizersPorts from '@/modules/warehouse/views/components/totalizers-ports/index.vue';
import SimpleCounterBlock from '@/modules/warehouse/views/components/SimpleCounterBlock.vue';
import ViewStatementModal from '@/modules/warehouse/views/pages/viewWarehouse/components/view-statement-modal/index.vue';
import formatters from '@/utils/formatters';
import { mapState, mapActions } from 'vuex';
import { Transactions } from '@/modules/warehouse/constants/TransactionsEnum';

export default {
    name: 'ViewWarehousePage',
    components: {
        BaseHeader,
        SearchFilters,
        WarehouseTransactionList,
        TotalizersPorts,
        SimpleCounterBlock,
        ViewStatementModal
    },
    computed: {
        ...mapState('warehouseModule', ['portFilter', 'loanTotalizers']),
        isPortView() {
            return this.$route.fullPath.indexOf('porto') !== -1;
        }
    },
    watch: {
        loanTotalizers: {
            handler(newVal) {
                this.processarDadosTotalizadores();
            },
            deep: true
        },
        '$i18n.locale': {
            handler() {
                this.processarDadosTotalizadores();
            }
        }
    },
    mounted() {
        if (
            !this.warehouseId &&
            (this.viewPendingOperations !== 'transacoes-pendentes' && this.viewPendingOperations !== 'troca-titularidade-pendentes')
        ) {
            this.$router.push({
                name: 'saldoArmazem'
            });
        } else {
            this.fetchLoanTotalizer(this.warehouseId);

            if (this.viewPendingOperations && this.viewPendingOperations !== '') {
                const newFilter = {
                    ...this.portFilter,
                    portId: this.warehouseId
                };
                this.setPortFilter(newFilter);
                this.fetchWarehouseInformation();
            }
        }
    },
    beforeDestroy() {
        const newFilter = {
            ...this.portFilter,
            portId: 0
        };
        this.setPortFilter(newFilter);
    },
    data() {
        return {
            warehouseId: this.$route.params.warehouseId,
            warehouseType: this.$route.params.type,
            viewPendingOperations: this.$route.params.viewPendingOperations,
            warehouseInformation: {},
            filters: {},
            pageType: ['PORTO', 'ARMAZEM'],
            showModalViewStatement: false,
            formattedLoanData: {}
        };
    },
    methods: {
        ...mapActions('warehouseModule', ['fetchLoanTotalizer']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },

        translateViewFactoryOperationsList() {
            return this.$t('warehouse.view_factory.operations_list');
        },

        getPageTitle() {
            this.getPageType();
            if (this.$route.fullPath.includes('porto')) {
                return this.translate('messages.ports');
            }
            return this.translate('messages.warehouses');
        },

        getPageType() {
            let pageType = null;
            for (let i = 0; i < this.pageType.length; i++) {
                if (this.$route.fullPath.includes(this.pageType[i].toLowerCase())) {
                    pageType = this.pageType[i];
                    i = this.pageType.length;
                }
            }

            return pageType;
        },

        changeFilters(filters) {
            let codigoStatus = null;
            if (!this.warehouseId) {
                codigoStatus = 'EM_TRANSITO';
                if (this.viewPendingOperations === 'troca-titularidade-pendentes') {
                    filters.idTipoTransacao = Transactions.TRANSFERENCIA_TITULARIDADE;
                }
            }
            this.filters = {
                idArmazem: this.warehouseId,
                codigoStatus: codigoStatus,
                ...filters
            };
        },

        async fetchWarehouseInformation() {
            if (this.warehouseId) {
                await ArmazemModuleService.getWarehouseInformation(this.warehouseId)
                .then(({ data }) => {
                    this.warehouseInformation = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.translate('messages.error_fetching_warehouse_information')
                    });
                });
            }
        },

        checkValidInformation(info) {
            if (info) {
                return info;
            } else {
                return '-';
            }
        },

        formatGeographicLocation() {
            const lat = this.warehouseInformation.latitudeY;
            const lon = this.warehouseInformation.longitudeX;
            if (lat == null || lon == null) {
                return '-';
            }
            const locale = this.$i18n.locale;
            return `${formatters.minFormatNumber(Number(lat), 4, locale)} / ${formatters.minFormatNumber(Number(lon), 4, locale)}`;
        },

        setPortFilter(newFilter) {
            this.$store.commit('warehouseModule/SET_PORT_FILTER', newFilter);
        },

        processarDadosTotalizadores() {
            if (!this.loanTotalizers) {
                this.formattedLoanData = {};
                return;
            }

            const formattedLoanData = {};

            Object.keys(this.loanTotalizers).forEach(key => {
                formattedLoanData[key] = {
                    detailText: this.translate(`messages.this_month`),
                    value: this.formatNumber(this.loanTotalizers[key].volumeTotalTon).toString() + ' t',
                    detailValue: this.formatNumber(this.loanTotalizers[key].volumeMensalTon).toString() + ' t'
                };

                if (key === 'volumeRecebido') {
                    formattedLoanData[key].counterColor = '#193CB8';
                    formattedLoanData[key].title = this.translate(`messages.received_volume`);
                } else if (key === 'volumeEnviado') {
                    formattedLoanData[key].counterColor = '#388E3C';
                    formattedLoanData[key].title = this.translate(`messages.sent_volume`);
                } else if (key === 'saldo') {
                    formattedLoanData[key].counterColor = this.loanTotalizers[key].volumeTotalTon >= 0 ? '#3B3B3B' : '#E41B1B';
                    formattedLoanData[key].detailColor = this.loanTotalizers[key].volumeMensalTon >= 0 ? '#3B3B3B' : '#E41B1B';
                    formattedLoanData[key].title = this.translate(`messages.balance`);
                }
            });

            this.formattedLoanData = formattedLoanData;
        },

        formatNumber(value) {
            if (value === null || value === undefined) return '-';
            return formatters.minFormatNumber(value, 2, this.$i18n.locale);
        },

        refreshLoanTotalizers() {
            this.fetchLoanTotalizer(this.warehouseId);
        },

        closeModal() {
            this.showModalViewStatement = false;
        }
    }
};
</script>

<style scoped lang="scss">
.view-invoices-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;

        .transaction-list {
            margin-top: 0 !important;
        }

        .counter-blocks_section {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 16px;
        }
    }

    .warehouse_operations_section {
        display: grid;
        grid-template-columns: 100%;
        gap: 16px;
        margin-top: 8px;
    }

    .warehouse-loan-control_section {
        display: grid;
        grid-template-columns: 100%;
        gap: 16px;
        margin-top: 8px;
    }

    .warehouse-info_section_header {
        margin-bottom: 0;
    }

    .view-statement__btn {
        border: 1px solid #183b57;
        font-size: 14px;
        padding: 9px 16px;
        height: 40px;
    }

    .warehouse-loan-control_section_header {
        margin-bottom: 0;
        display: flex;
        justify-content: space-between;
    }

    .operations_history_section_title {
        color: var(--float-box-section-title-color, #666666);
        font-weight: 700;
        font-size: 16px;
        margin: 12px 0 0 0;
    }

    .loan-control_section_title {
        color: var(--float-box-section-title-color, #666666);
        font-weight: 700;
        font-size: 16px;
        margin: 12px 0 0 0;
    }

    .upload_section {
        display: block;

        .upload_card {
            padding: 16px;
            background: white;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            font-size: 14px;

            .warehouse-info {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 12px 16px;
                width: 100%;

                @media (max-width: 1200px) {
                    grid-template-columns: repeat(2, 1fr);
                }

                @media (max-width: 768px) {
                    grid-template-columns: 1fr;
                }
            }

            .warehouse-info--five-columns {
                grid-template-columns: repeat(5, 1fr);

                @media (max-width: 1200px) {
                    grid-template-columns: repeat(2, 1fr);
                }

                @media (max-width: 768px) {
                    grid-template-columns: 1fr;
                }
            }

            .warehouse-info_field {
                display: flex;
                flex-direction: column;
            }

            .warehouse-info_text {
                word-break: break-word;
                line-height: 1.4;
            }

            .warehouse-info_header {
                margin-bottom: 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .warehouse-info_title {
                color: #00413c;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 8px;
                margin: 0;
            }

            .warehouse-icon {
                font-weight: normal !important;
            }

            .warehouse-info_field .warehouse-info_label {
                color: #00413c;
                font-weight: 600;
                line-height: 1.2;
                margin-bottom: 4px;
            }
        }
    }
}
</style>
